import Echo from "laravel-echo";
import {cookie, Env} from "@morningtrain/helpers";

const router       = require("app/services/router");
const pusherConfig = Env.get('broadcasting.pusher');

let EchoConnection = {};

if (pusherConfig) {
    EchoConnection = new Echo({
        authEndpoint: router.url('broadcasting/auth'),
        auth:         {
            headers: {
                'x-xsrf-token': cookie.get('XSRF-TOKEN'),
            },
        },
        broadcaster:  'pusher',
        key:          pusherConfig.key,
        cluster:      pusherConfig.cluster,
        encrypted:    pusherConfig.encrypted,
    });
}

export default EchoConnection;
